import * as React from 'react';

import { Loader } from 'components/loader/Loader';

import { IProps, IState } from './GoogleAnalyticsChartsProvider.types';

export class GoogleAnalyticsChartsProvider extends React.Component<
  IProps,
  IState
> {
  public state = {
    isReady: false,
  };

  public componentDidMount() {
    // TODO EAG-2220
    this.init();
  }

  public render() {
    return this.state.isReady ? this.props.children : <Loader />;
  }

  private readonly init = () => {
    if (!(window as any).gapi) {
      return;
    }

    const doAuth = () => {
      const authObj = {
        serverAuth: { access_token: this.props.accessToken },
      } as any;

      (window as any).gapi.analytics.auth.authorize({
        ...authObj,
      });
    };

    (window as any).gapi.analytics.ready(() => {
      const authResponse = (window as any).gapi.analytics.auth.getAuthResponse();

      if (!authResponse) {
        (window as any).gapi.analytics.auth.on('success', () => {
          this.setState({
            isReady: true,
          });
        });
      } else {
        this.setState({
          isReady: true,
        });
      }
      doAuth();
    });
  };
}
